import type { Poll, Program, ProgramPollContentObjectList } from 'models';
import { can } from 'old/utils/permissions';

import { Flex } from 'ui';
import { PollRendererCore } from 'features/polls';
import { Footer } from '../footer';
import { ProgramTimelineItemHeader } from '../program-timeline-item-header';

const toPollDraft = (item: ProgramPollContentObjectList): Poll => ({
  attachments: item.attachments,
  description: item.poll.description,
  endTime: item.poll.endTime,
  htmlDescription: item.poll.htmlDescription,
  id: item.poll.id,
  pinned: item.pinned,
  postInCommunities: [],
  programsTopicId: item.programsTopic.id,
  questions: item.poll.questions,
  startTime: item.poll.startTime,
  title: item.poll.title,
});

type P = {
  'data-test-id'?: string;
  item: ProgramPollContentObjectList;
  program: Program;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
const ProgramPollTimelineItem = ({ 'data-test-id': dataTestId, item, program }: P) => {
  const isProgramPublished = program.status === 'published';

  return (
    <Flex data-test-id={dataTestId} gap="md" vertical>
      <ProgramTimelineItemHeader item={item} program={program} />

      <PollRendererCore
        isDisabled={Boolean(can(program, 'Program', 'editProgramContent'))}
        poll={toPollDraft(item)}
        showChoicePercentage={Boolean(can(program, 'Program', 'editProgramContent'))}
      />

      <Footer isProgramPublished={isProgramPublished} item={item} program={program} />
    </Flex>
  );
};

export default ProgramPollTimelineItem;
